
import AddWatchlistButton from '@/components/buttons/AddWatchlistButton'
import Bookmark from '@/components/cards/Bookmark'
import { mdiVideoImage, mdiStar } from '@mdi/js'

export default {
  name: 'MediaCard',
  data() {
    return {
      svgVideoImage: mdiVideoImage,
      svgStar: mdiStar,
    }
  },
  props: {
    media: {
      type: Object,
      required: true
    }
  },
  components: {
    AddWatchlistButton,
    Bookmark
  },
  computed: {
    mediaType() {
      if (this.media) {
        return this.media.name ? "tvshows" : "movies"
      }
    },
    mediaTitle() {
      return this.media.name ? this.media.name : this.media.title
    },
    has_poster: function () {
      if (this.media.poster_path != null) { return true; }
      return false;
    },
    mediaReleaseYear() {
      //if its a tv series
      if (this.media.name) {
        return new Date(this.media.first_air_date).toLocaleString('en-US', {
          year: 'numeric',
        })
      }
      //its a movie
      return new Date(this.media.release_date).toLocaleString('en-US', {
        year: 'numeric',
      });

    },
  }
}
